import React from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import { ProjectCard } from './ProjectCard';
import projImg1 from '../assets/images/Screenshot 2024-06-12 151437.png';
import projImg2 from '../assets/images/sss.png';
import projImg3 from '../assets/images/poonam.png';
import projImg4 from '../assets/images/bytecraft.png';
import projImg5 from '../assets/images/ss.png';
import projImg7 from '../assets/images/drunl.png';
import colorSharp2 from '../assets/img/color-sharp2.png';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {
  const projects = [
    //   {
    //   title: "Poonam Enterprise",
    //   description: "Dynamic Platform for Selling CCTV Systems Plans",
    //   imgUrl: projImg3,
    //   techStack: ["React", "Laravel", "PHP", "MySQL", "Bootstrap", "JavaScript"],
    //   link: "https://thepoonamenterprises.in/", 
    //   details: "Created a dynamic website for Poonam Enterprise to sell CCTV systems and other related products. This platform features comprehensive dashboards for users, customers, and admins, allowing for efficient management of products, orders, and customer interactions. Implemented features include interactive customer plans, real-time data visualization, and a responsive design tailored for seamless user experiences across devices.",
    //   category: "Web Development"
    // },
    // {
    //   title: "Byte Craft Studios",
    //   description: "Website for Byte Craft Studios",
    //   imgUrl: projImg4,
    //   techStack: ["Laravel", "PHP", "MySQL", "Bootstrap", "JavaScript"],
    //   link: "https://laravel.bytecraftstudios.in/",
    //   details: "Developed a comprehensive website for Byte Craft Studios using Laravel. This website showcases various services and features a user-friendly interface with a focus on clean design and efficient functionality. Utilized Laravel along with other technologies to ensure a robust and scalable platform for the client.",
    //   category: "Web Development"
    // },
    // {
    //   title: "ConnectVerse - DigitalConnect",
    //   description: "Uniting Digital Realms for Dynamic Engagement",
    //   imgUrl: projImg1,
    //   techStack: ["PHP", "MySQL", "Bootstrap", "CSS", "JavaScript"],
    //   link: "https://github.com/mohitarora786/ConnectVerse.git",
    //   details: "Developed ConnectVerse, a cutting-edge digital platform that integrates customizable blogs, task scheduling, and social connectivity features. Utilized PHP, MySQL, Bootstrap, CSS, and JavaScript to create a solution that supports over 10,000 users with a 99% uptime. Achieved a 50% increase in user engagement through intuitive design and streamlined functionality, and reduced task management time by 35% with efficient scheduling tools.",
    //   category: "Web Development"
    // },
    // {
    //   title: "SoundScape",
    //   description: "Dynamic E-Commerce Platform for Premium Audio Products",
    //   imgUrl: projImg2,
    //   techStack: ["Quasar Framework", "JavaScript"],
    //   link: "https://github.com/mohitarora143/ProductRecommendationSystem.git", 
    //   details: "Developed SoundScape, a high-performance e-commerce platform utilizing the Quasar Framework to showcase and sell premium audio products. Implemented features such as an animated user interface, responsive design, and real-time product filtering, which led to a 60% increase in user retention and a 45% boost in conversion rates. The seamless checkout process reduced cart abandonment by 35%, significantly improving overall customer satisfaction.",
    //   category: "Web Development"
    // },
    // {
    //   title: "Hostel Management IIITM",
    //   description: "Comprehensive Hostel Management System",
    //   imgUrl: projImg5,
    //   techStack: ["PHP", "MySQL"],
    //   link: "https://github.com/mohitarora143/Hostel-Management.git",
    //   details: "Developed a Hostel Management System as a college project during the 5th semester. The system includes functionalities for managing transactions, seat allocations, and hostel allotments. This project was designed to streamline hostel operations and enhance administrative efficiency.",
    //   category: "Web Development"
    // },
    // {
    //   title: "Deep Learning + Machine Learning",
    //   description: "Drunkenness detector using deep learning",
    //   imgUrl: projImg7,
    //   techStack: ["Python", "TensorFlow", "Keras"],
    //    link:"https://drive.google.com/file/d/1I43Kqx5wjFPXHkw2CQPlLlSHSga46wgy/view?usp=sharing",
    //   details: "Created a machine learning model to detect drunkenness using deep learning techniques. Utilized Python, TensorFlow, and Keras to train a model that accurately predicts levels of inebriation based on various input features. This project highlights advanced capabilities in machine learning and neural networks.",
    //   category: "Machine Learning"
    // }
    // Add more projects as needed
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Projects</h2>
                <p>Explore some of the projects I’ve worked on, showcasing a variety of technologies and applications. From full-stack web development to machine learning innovations, these projects highlight my skills and experience across different domains.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="all">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="all">All Projects</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="web-dev">BlockChain </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="ml">AI/ML</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="all">
                      <Row>
                        {
                          projects.map((project, index) => (
                            <ProjectCard
                              key={index}
                              title={project.title}
                              description={project.description}
                              imgUrl={project.imgUrl}
                              techStack={project.techStack}
                              link={project.link}
                              details={project.details}
                            />
                          ))
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="web-dev">
                      <Row>
                        {
                          projects.filter(project => project.category === "Web Development").map((project, index) => (
                            <ProjectCard
                              key={index}
                              title={project.title}
                              description={project.description}
                              imgUrl={project.imgUrl}
                              techStack={project.techStack}
                              link={project.link}
                              details={project.details}
                            />
                          ))
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="ml">
                      <Row>
                        {
                          projects.filter(project => project.category === "Machine Learning").map((project, index) => (
                            <ProjectCard
                              key={index}
                              title={project.title}
                              description={project.description}
                              imgUrl={project.imgUrl}
                              techStack={project.techStack}
                              link={project.link}
                              details={project.details}
                            />
                          ))
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="background" />
    </section>
  );
};
